// 用户管理
export default {
    name: 'Name',
    userName: 'user name',
    role: 'role',
    mobileNumberQuery: 'Mobile number query',
    pleaseChoose: 'please choose',
    cellphoneNumber: 'cellphone number',
    licenseType: 'License Type',
    department: 'Department',
    addUser: 'Add user',
    editUser: 'edit user',
    pilotCertification: 'Pilot Certification',
    pendingCertification: 'pending certification',
    fail: 'Fail',
    certificationInformation: 'Certification Information',
    passThrough: 'pass through',
    remark: 'Remark',
    check: 'Check',
    verified: 'verified',
    certificationResult: 'Certification result',
    notCertified: 'not certified',
    freeze: 'freeze',
    certification: 'Certification',
    userAccount: 'User Account',
    pleaseEnter: 'please enter',
    contactInformation: 'Contact information',
    isDepartment: 'Department',
    userRole: 'user role',
    passwordSetting: 'password setting',
    operate: 'operate',
    enterPassword: 'Please enter password',
    changePassword: 'change Password',
    userAddSuccessfully: 'User added successfully',
    userEditSuccessfully: 'User edited successfully',
    personalInfoAuthentication: 'Personal Information Authentication',
    loginPassword: 'login password',
    copyAccountPwd: 'Copy account password',
    verifieds: 'Verified',
    actualName: 'actual name',
    idNumber: 'ID number',
    idPhoto: 'ID photo',
    addidfacephoto: 'Add ID face photo',
    ptneotIDc: 'Photo of the national emblem of the ID card',
    addptneotIDc: 'Add a photo of the national emblem of the ID card',
    authenticationType: 'Authentication type',
    model: 'model',
    upload: 'upload',
    grade: 'grade',
    IDPhoto: 'ID Photo',
    addIDPhoto: 'Add ID profile photo',
    potrsotd: 'Photo of the reverse side of the document',
    addpotrsotd: 'Add photo of the reverse side of the document',
    mobileFormatError: 'Malformed phone number',
    idNumberFormatError: 'ID number format error',
    addressEncodingError: 'address encoding error',
    CheckDigitError: 'Check digit error',
    automaticGenerated: 'Automatic generated',
    manualEntry: 'Manual entry',
    allow: 'allow',
    prohibit: 'prohibit',
    pleaseEnterDept: 'Please select a department',
    pleaseEnterUsername: 'Please enter username',
    pleaseEnterUserAccount: 'Please enter user account',
    pleaseSelectUserRole: 'Please select a user role',
    pleaseSelectPasswordSetting: 'Please select a password setting',
    pleaseEnterYourRealName: 'please enter your real name',
    plidentificationNumber: 'Please enter identification number',
    PeCorrectIDNumber: 'Please enter the correct ID number',
    pUploadIdPhoto: 'Please upload your ID photo',
    uploadIdCardEm: 'Please upload a photo of your ID card and national emblem',
    selectAuthenticationType: 'Please select an authentication type',
    pleaseSelectModel: 'Please select a model',
    pleaseSelectLevel: 'Please select a level',
    uploadPassportPhoto: 'Please upload your passport photo',
    uploadPhotoBackYourXId: 'Please upload a photo of the back of your ID',
    copySuccessfully: 'Copy successfully',
    replicationFailed: 'Replication failed',
    uploadImgFormatWrong: 'The uploaded image is in the wrong format',
    confirmWhetherRestore: 'Please confirm whether to restore',
    recover: 'recover',
    successfulOperation: 'Successful operation',
    delUserTip: 'After the user is deleted, it cannot be recovered, please operate with caution!',
    frozenTip: 'Notice! After the user is frozen, he cannot log in to the system, but the user data is still retained!',
    editSuccessTip:'The modification is successful, and it will take effect after logging in again.'
}
